import { render } from "./FireForgotPassword.vue?vue&type=template&id=6e7a3793"
import script from "./FireForgotPassword.vue?vue&type=script&lang=ts"
export * from "./FireForgotPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script